import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { checkButtonDisabled } from '../../utils/forms';

export default class NewOrderFormFour extends React.Component {
  static propTypes = {
    change: PropTypes.func.isRequired,
    escapeForm: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    invalid: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    previousPageFunction: PropTypes.func.isRequired,
    submitFunction: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  componentDidMount = () => {
    window.addEventListener('message', this.receiveOrder, false);
  };

  componentWillUnmount = () => {
    window.removeEventListener('message', this.receiveOrder, false);
  };

  receiveOrder = evt => {
    const { submitFunction } = this.props;
    // We need to make sure the origin matches (to prevent XSS)
    if (evt.origin === document.location.origin) {
      if (evt.data === 'continue') submitFunction(4);
      else this.props.change('segmentBuilderFilters', evt.data);
    }
  };

  render() {
    const {
      previousPageFunction,
      escapeForm,
      formValues: { skuId, platformCode },
      submitFunction,
      invalid,
      isSuperAdmin,
      submitting,
    } = this.props;

    let iframeURL = '';

    // Only display if we have the SKU
    if (skuId) {
      const skuObj = JSON.parse(skuId);
      const datasetIdParam = skuObj.datasetId;
      iframeURL = `../../search_frame/segment_builder/${datasetIdParam}/${platformCode}`;
      if (isSuperAdmin) iframeURL = `../${iframeURL}`;
    }

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body align-items-center">
              <div className="row">
                <div className="col-sm-12">
                  <span className="pull-right">
                    <button
                      type="button"
                      className="btn btn-danger-outline"
                      onClick={() => escapeForm()}
                    >
                      Cancel
                    </button>
                  </span>
                  <h1 className="header-title">Partial File</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card-border">
                <div className="card-header">
                  <div className="card-header-title">Segment Builder</div>
                </div>
                <div className="card-block">
                  <div className="container" style={{ maxWidth: '100%' }}>
                    <div className="card card-block" style={{ paddingBottom: '0' }}>
                      {skuId ? (
                        <iframe
                          src={iframeURL}
                          className="container iframe-full-width order-iframe"
                          title="Prospecting Page"
                        />
                      ) : (
                        <div className="row">
                          <div className="col-sm-12 col-md-6">
                            <p>
                              Hmm...it appears you have not selected a SKU from the previous page.
                            </p>
                            <p>Please go back and select a SKU first.</p>
                          </div>
                        </div>
                      )}
                    </div>
                    <hr />
                    <form className="small-form">
                      <fieldset>
                        <Field
                          name="segmentBuilderFilters"
                          label=""
                          type="hidden"
                          component="input"
                        />
                        <div className="form-buttons">
                          <p className="pull-right">
                            <button
                              type="button"
                              className="btn btn-secondary btn-back"
                              onClick={previousPageFunction}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={submitFunction}
                              disabled={checkButtonDisabled(invalid, submitting)}
                            >
                              Continue
                            </button>
                          </p>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
